import { useApi } from "./api";

export const useDocumentTypeService = () => {
  const api = useApi();
  
  return {
    getAllDocumentTypes: async () => {
      try {
        const response = await api.get("/document-types");
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    getDocumentTypeById: async (id) => {
      try {
        const response = await api.get(`/document-types/${id}`);
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    createDocumentType: async (documentType) => {
      try {
        const response = await api.post("/document-types", documentType);
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    updateDocumentType: async (id, documentType) => {
      try {
        const response = await api.put(`/document-types/${id}`, documentType);
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    deleteDocumentType: async (id) => {
      try {
        const response = await api.delete(`/document-types/${id}`);
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },
  };
};
export const usePhoneCountryCodeService = () => {
  const api = useApi();
  
  return {
    getAllPhoneCountryCodes: async () => {
      try {
        const response = await api.get("/phone-country-codes");
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    getPhoneCountryCodeById: async (id) => {
      try {
        const response = await api.get(`/phone-country-codes/${id}`);
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    createPhoneCountryCode: async (countryCode) => {
      try {
        const response = await api.post("/phone-country-codes", countryCode);
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    updatePhoneCountryCode: async (id, countryCode) => {
      try {
        const response = await api.put(`/phone-country-codes/${id}`, countryCode);
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    deletePhoneCountryCode: async (id) => {
      try {
        const response = await api.delete(`/phone-country-codes/${id}`);
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },
  };
};

// ─── Servicio: Asignaciones de operadores a gestores CUV/LUV ───────────────
export const useUserOperatorAssignmentsService = () => {
  const api = useApi();

  return {
    getManagers: async () => {
      try {
        const response = await api.get("/user-operator-assignments/managers");
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    getOperatorsByManager: async (managerId, { searchTerm = "", page = 1, limit = 10 } = {}) => {
      try {
        const response = await api.get(
          `/user-operator-assignments/${managerId}/operators`,
          { params: { searchTerm, page, limit } }
        );
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    getAvailableOperators: async (managerId, searchTerm = "") => {
      try {
        const response = await api.get(
          `/user-operator-assignments/${managerId}/available-operators`,
          { params: { searchTerm } }
        );
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    assign: async (managerId, operatorId) => {
      try {
        const response = await api.post("/user-operator-assignments/assign", { managerId, operatorId });
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    assignBatch: async (managerId, operatorIds) => {
      try {
        const response = await api.post("/user-operator-assignments/assign-batch", { managerId, operatorIds });
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    remove: async (managerId, operatorId) => {
      try {
        const response = await api.delete(
          `/user-operator-assignments/${managerId}/operators/${operatorId}`
        );
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    removeBatch: async (managerId, operatorIds) => {
      try {
        const response = await api.delete(
          `/user-operator-assignments/${managerId}/operators`,
          { data: { operatorIds } }
        );
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },
  };
};

// ─── Servicio: Asignaciones de vehículos a gestores CUV/LUV ────────────────────────────────────
export const useUserVehicleAssignmentsService = () => {
  const api = useApi();

  return {
    getManagers: async () => {
      try {
        const response = await api.get("/user-vehicle-assignments/managers");
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    getVehiclesByManager: async (managerId, { searchTerm = "", page = 1, limit = 10 } = {}) => {
      try {
        const response = await api.get(`/user-vehicle-assignments/${managerId}/vehicles`, {
          params: { searchTerm, page, limit },
        });
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    getAvailableVehicles: async (managerId, searchTerm = "") => {
      try {
        const response = await api.get(`/user-vehicle-assignments/${managerId}/available-vehicles`, {
          params: { searchTerm },
        });
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    assign: async (managerId, vehicleId) => {
      try {
        const response = await api.post("/user-vehicle-assignments/assign", { managerId, vehicleId });
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    assignBatch: async (managerId, vehicleIds) => {
      try {
        const response = await api.post("/user-vehicle-assignments/assign-batch", { managerId, vehicleIds });
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    remove: async (managerId, vehicleId) => {
      try {
        const response = await api.delete(`/user-vehicle-assignments/${managerId}/vehicles/${vehicleId}`);
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    removeBatch: async (managerId, vehicleIds) => {
      try {
        const response = await api.delete(
          `/user-vehicle-assignments/${managerId}/vehicles`,
          { data: { vehicleIds } }
        );
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },
  };
};
